export default {
    titulo: "Works",
    nueva: "New work",
    editar: "Edit work",
    codigo: "Code",
    descripcion: "Description",
    fecha: "Start date",
    sucursal: "Branch",
    estado: "Status",
    activa: "Active",
    finalizada: "Finished",
    fechaFin: "End date",
    buscar: "Search by description",
    fechaIni: "From",
    fechaHasta: "To",
    todas: "All",
    finalizar: "Finish",
    finalizarTitulo: "Finish work",
    pregFinalizar: "Do you want to finish this work? You can reactivate it later.",
    reactivar: "Reactivate",
    eliminar: "Delete",
    eliminarTitulo: "Delete work",
    pregEliminar: "Do you want to delete this work? This action cannot be undone.",
    guardar: "Save",
    obraCreada: "Work created successfully",
    obraActualizada: "Work updated successfully",
};
